// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"69f626f812e3ea28d3d8","3":"252e8d7fc194be746e63","4":"58dc4c2cf5185762df17","5":"7ec4eaa1ea7d72af59a8"}[chunkId] + "";
};